function controllItemLimits(cart) {
  const cartProductIds = []; // track products added to cart, set max input value for selectors to limit for remaining qty selectors
  const currentCart = theme.cart;
  if (!!currentCart) {
    const cartItems = currentCart.items
    if (!!cartItems && cartItems.length > 0) {
      cartItems.forEach((cartItem) => {
        const productId = cartItem.product_id;
        cartProductIds.push(productId);
        const productQty = parseInt(cartItem.quantity);
        const addToCartForms = document.querySelectorAll(`form[action$="/cart/add"][product-id="${productId}"]`);
        if (addToCartForms.length > 0) {
          addToCartForms.forEach((atcForm) => {
            const itemLimit = atcForm.getAttribute('product-cart-limit') ? parseInt(atcForm.getAttribute('product-cart-limit')) : 0;
            if (itemLimit != 0) {
              const productAddableQty = itemLimit - productQty;
              const atcButtons = atcForm.querySelectorAll('[type="submit"]');
              if (productAddableQty <= 0) {
                //disable ATCs and qty+ 
                atcButtons.forEach((atc) => {
                  atc.setAttribute('limit_reached', '');
                })
                atcForm.setAttribute('limit_reached', '');
              } else {
                //if product was removed from cart: handled@// qty selectors of products that are not in the cart
                atcButtons.forEach((atc) => {
                  atc.removeAttribute('limit_reached');
                })
                atcForm.removeAttribute('limit_reached');
              }
            }
          })
        }
        //not all qty selectors are placed inside of forms
        const qtySelectors = document.querySelectorAll(`quantity-counter[product-id="${productId}"]`);
        qtySelectors.forEach((qtySelector) => {
          const itemLimit = qtySelector.hasAttribute('product-cart-limit') ? Number(qtySelector.getAttribute('product-cart-limit')) : 0;
          const itemMinimum = qtySelector.hasAttribute('product-cart-minimum') ? Number(qtySelector.getAttribute('product-cart-minimum')) : 1;
          const input = qtySelector.querySelector('[data-quantity-field]');
          if (!!input) {
            const parentForm = input.closest('form[action$="/cart/add"]');
            if (!!parentForm && !parentForm.hasAttribute('data-cart-form')) {
              if(itemLimit != 0) {
                let productAddableQty = itemLimit - productQty;
                if (productAddableQty <= 0) {
                  productAddableQty = 1;
                }
                // qty will be added to cart, set max addable amount
                input.setAttribute('max', productAddableQty);
              }
              if(itemMinimum) {
                let cartCorrectedMinimum = Math.max(itemMinimum - productQty, 0);
                input.setAttribute('min', cartCorrectedMinimum);
              }
            } else {
              // input value is current qty, set max to limit
              input.setAttribute('max', itemLimit);
              input.setAttribute('min', itemMinimum);
            }
          }
        })
        const altQuantitySelectors = document.querySelectorAll(`popout-select[product-id="${productId}"]`);
        altQuantitySelectors.forEach((qtySelector) => {
          const itemLimit = qtySelector.hasAttribute('product-cart-limit') ? Number(qtySelector.getAttribute('product-cart-limit')) : 0;
          const itemMinimum = qtySelector.hasAttribute('product-cart-minimum') ? Number(qtySelector.getAttribute('product-cart-minimum')) : 1;
          const addableQty = itemLimit - productQty;
          const cartCorrectedMinimum = Math.max(itemMinimum - productQty);
          const quantityValueContainers = qtySelector.querySelectorAll('.select-popout__list__scroll li');
          const form = qtySelector.closest('form');
          // item limit cant be 0 
          if ((itemLimit != 0 && productQty >= itemLimit) && !!form && !form.hasAttribute('data-cart-form')) {
            qtySelector.setAttribute('disabled', '');
          } else {
            qtySelector.removeAttribute('disabled');
            quantityValueContainers.forEach((valueContainer) => {
              const valueButton = valueContainer.querySelector('.select-popout__option');
              if (!!form && !form.hasAttribute('data-cart-form')) {
                // for inside cart forms
                valueContainer.classList.remove('hidden');
                if (itemLimit != 0 && Number(valueButton.getAttribute('data-value')) > addableQty) {
                  valueContainer.classList.add('hidden');
                }
                if (Number(valueButton.getAttribute('data-value')) < cartCorrectedMinimum) {
                  valueContainer.classList.add('hidden');
                }
              } else {
                // outside of form (sets qty)
                valueContainer.classList.remove('hidden');
                if (itemLimit != 0 && Number(valueButton.getAttribute('data-value')) > itemLimit) {
                  valueContainer.classList.add('hidden');
                }
                if (Number(valueButton.getAttribute('data-value')) < itemMinimum) {
                  valueContainer.classList.add('hidden');
                }
              }
            });
            const has_valid_selection = !!qtySelector.querySelector('.select-popout__item.select-popout__item--current:not(.hidden)');
            if(!has_valid_selection) {
              const first_valid_selection = qtySelector.querySelector('.select-popout__item:not(.hidden)');
              first_valid_selection?.classList?.add('select-popout__item--current');
              if(qtySelector.querySelector('[data-popout-text]') && first_valid_selection?.querySelector('[data-value]')?.dataset?.value) {
                qtySelector.querySelector('[data-popout-text]').innerHTML = first_valid_selection?.querySelector('[data-value]')?.dataset?.value;
              }
            }
          }
        })
      })
    }
  } else {
    console.log('error fetching cart')
  }
  // qty selectors of products that are not in the cart
  const productForms = document.querySelectorAll('form[action$="/cart/add"]');
  productForms.forEach((productForm) => {
    const productId = productForm.getAttribute('product-id');
    const productLimit = Number(productForm.getAttribute('product-cart-limit'));
    const productMinimum = Number(productForm.getAttribute('product-cart-minimum'));
    const qtySelector = productForm.querySelector('quantity-counter');
    const altQtySelector = productForm.querySelector('popout-select');
    const input = qtySelector?.querySelector('[data-quantity-field]');

    if (!!productId) {
      if (cartProductIds.includes(parseInt(productId))) {
        // do nothing product is in cart and has been handled
      } else {
        //case: products have been removed from cart -> enable atc
        productForm.removeAttribute('limit_reached');
        const atcs = productForm.querySelectorAll('[type="submit"]');
        atcs.forEach((atc) => {
          atc.removeAttribute('limit_reached')
        });
        if (!!input) {
          // product is not in cart, set max value to limit
          if(productLimit > 0){
            input.setAttribute('max', productLimit);
          }
          input.setAttribute('min', productMinimum);
          if(productLimit > 0) {
            input.setAttribute('value', Math.min(Math.max(productMinimum, Number(input.value)), productLimit));
          } else {
            input.setAttribute('value', Math.max(productMinimum, Number(input.value)));
          }
        }
        if (!!altQtySelector) {
          const quantityValueContainers = altQtySelector.querySelectorAll('.select-popout__list__scroll li');
          quantityValueContainers.forEach((valueContainer) => {
            const valueButton = valueContainer.querySelector('.select-popout__option');
            const value = Number(valueButton.getAttribute('data-value'));
            valueContainer.classList.remove('hidden');
            if (productLimit != 0 && value > productLimit) {
              valueContainer.classList.add('hidden');
            }
            if(value < productMinimum) {
              valueContainer.classList.add('hidden');
            }
          });
          const has_valid_selection = !!altQtySelector.querySelector('.select-popout__item.select-popout__item--current:not(.hidden)');
          if(!has_valid_selection) {
            const first_valid_selection = altQtySelector.querySelector('.select-popout__item:not(.hidden)');
            first_valid_selection.classList.add('select-popout__item--current');
            if(altQtySelector.querySelector('[data-popout-text]') && first_valid_selection?.querySelector('[data-value]')?.dataset?.value) {
              altQtySelector.querySelector('[data-popout-text]').innerHTML = first_valid_selection?.querySelector('[data-value]')?.dataset?.value;
            }
          }
        }
      }
    }
  })
}

// Fire function on events
document.addEventListener('DOMContentLoaded', (e) => { //fire a soon as the doc content is loaded to avoid 'flicker' of inital value
  controllItemLimits(theme?.cart);
});
window.addEventListener('load', (e) => { //fire again when everything is loaded, incase forms have been added
  controllItemLimits(theme?.cart);
});
document.addEventListener('theme:cart:added', (e) => {
  fetch(window.Shopify.routes.root + 'cart.js').then(data => data.json()).then(data => {
    theme.cart = data;
    controllItemLimits();
  });
});
document.addEventListener('theme:cart:updated', (e) => {
  theme.cart = e.detail;
  controllItemLimits();
});
// content added
document.addEventListener('theme:cart:open', (e) => {
  controllItemLimits();
});
// collection filter applied
document.addEventListener('filter:applied', (e) => {
  controllItemLimits();
});